var map = {
	"./SpinGeneralMacro_001.webp": 29187,
	"./SpinGeneralMacro_002.webp": 94079,
	"./SpinGeneralMacro_003.webp": 41377,
	"./SpinGeneralMacro_004.webp": 90343,
	"./SpinGeneralMacro_005.webp": 64437,
	"./SpinGeneralMacro_006.webp": 26350,
	"./SpinGeneralMacro_007.webp": 50292,
	"./SpinGeneralMacro_008.webp": 13466,
	"./SpinGeneralMacro_009.webp": 46731,
	"./SpinGeneralMacro_010.webp": 33076,
	"./SpinGeneralMacro_011.webp": 50599,
	"./SpinGeneralMacro_012.webp": 73925,
	"./SpinGeneralMacro_013.webp": 149,
	"./SpinGeneralMacro_014.webp": 32816,
	"./SpinGeneralMacro_015.webp": 64244,
	"./SpinGeneralMacro_016.webp": 37878,
	"./SpinGeneralMacro_017.webp": 43075,
	"./SpinGeneralMacro_018.webp": 58701,
	"./SpinGeneralMacro_019.webp": 19015,
	"./SpinGeneralMacro_020.webp": 2928,
	"./SpinGeneralMacro_021.webp": 38279,
	"./SpinGeneralMacro_022.webp": 25337,
	"./SpinGeneralMacro_023.webp": 26482,
	"./SpinGeneralMacro_024.webp": 28011,
	"./SpinGeneralMacro_025.webp": 42773,
	"./SpinGeneralMacro_026.webp": 22915,
	"./SpinGeneralMacro_027.webp": 46982,
	"./SpinGeneralMacro_028.webp": 7421,
	"./SpinGeneralMacro_029.webp": 73231,
	"./SpinGeneralMacro_030.webp": 78933,
	"./SpinGeneralMacro_031.webp": 2722,
	"./SpinGeneralMacro_032.webp": 11239,
	"./SpinGeneralMacro_033.webp": 83691,
	"./SpinGeneralMacro_034.webp": 99581,
	"./SpinGeneralMacro_035.webp": 6887,
	"./SpinGeneralMacro_036.webp": 60454,
	"./SpinGeneralMacro_037.webp": 464,
	"./SpinGeneralMacro_038.webp": 55882,
	"./SpinGeneralMacro_039.webp": 97464,
	"./SpinGeneralMacro_040.webp": 55241,
	"./SpinGeneralMacro_041.webp": 88741,
	"./SpinGeneralMacro_042.webp": 41701,
	"./SpinGeneralMacro_043.webp": 48633,
	"./SpinGeneralMacro_044.webp": 96145,
	"./SpinGeneralMacro_045.webp": 49731,
	"./SpinGeneralMacro_046.webp": 31608,
	"./SpinGeneralMacro_047.webp": 40443,
	"./SpinGeneralMacro_048.webp": 44707,
	"./SpinGeneralMacro_049.webp": 82713,
	"./SpinGeneralMacro_050.webp": 97443,
	"./SpinGeneralMacro_051.webp": 36533,
	"./SpinGeneralMacro_052.webp": 13784,
	"./SpinGeneralMacro_053.webp": 73911,
	"./SpinGeneralMacro_054.webp": 10613,
	"./SpinGeneralMacro_055.webp": 60761,
	"./SpinGeneralMacro_056.webp": 42766,
	"./SpinGeneralMacro_057.webp": 93233,
	"./SpinGeneralMacro_058.webp": 68326,
	"./SpinGeneralMacro_059.webp": 88500,
	"./SpinGeneralMacro_060.webp": 94334,
	"./SpinGeneralMacro_061.webp": 37778,
	"./SpinGeneralMacro_062.webp": 65210,
	"./SpinGeneralMacro_063.webp": 28167,
	"./SpinGeneralMacro_064.webp": 10967,
	"./SpinGeneralMacro_065.webp": 27448,
	"./SpinGeneralMacro_066.webp": 58521,
	"./SpinGeneralMacro_067.webp": 41996,
	"./SpinGeneralMacro_068.webp": 70916,
	"./SpinGeneralMacro_069.webp": 41360,
	"./SpinGeneralMacro_070.webp": 47993,
	"./SpinGeneralMacro_071.webp": 48620,
	"./SpinGeneralMacro_072.webp": 25467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86132;